import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DataSharingService {
  public notificationsRaw: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public mediaQueue: BehaviorSubject<any> = new BehaviorSubject<any>([]);
}
